// extracted by mini-css-extract-plugin
export default {"container":"Ml-z","blurb":"Nl-z","links":"Ol-z"};